import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HighchartsChartModule } from 'highcharts-angular';
import { CurrencyMaskInputMode, NgxCurrencyModule } from 'ngx-currency';
import { IConfig, NgxMaskModule } from 'ngx-mask';
import { CmaModule } from "src/app/cma/cma.module";
import { SharedModule } from '../_shared/shared.module';
import { NavigationModule } from '../navigation/navigation.module';
import { ContactAgentInfoComponent } from './component/contact-agent-info/contact-agent-info.component';
import { CreateMortgageDialogComponent } from './component/create-mortgage-dialog/create-mortgage-dialog.component';
import { CreateMyHomeDialogueComponent } from './component/create-my-home-dialogue/create-my-home-dialogue.component';
import { CreateRefinanceMortgageScenarioDialogComponent } from './component/create-refinance-mortgage-scenario-dialog/create-refinance-mortgage-senerio-dialog.component';
import { ExtraPaymentComponent } from './component/extra-payment/extra-payment.component';
import { FinancingComponent } from './component/financing/financing.component';
import { HomePropertyDetailsComponent } from './component/home-property-details/home-property-details.component';
import { MaintenanceAlertsComponent } from './component/maintenance-alerts/maintenance-alerts.component';
import { ManageMaintenanceAlertsComponent } from './component/manage-maintenance-alerts/manage-maintenance-alerts.component';
import { MiniBarChartComponent } from './component/mini-bar-chart/mini-bar-chart.component';
import { MortgageGroupComponent } from './component/mortgage-group/mortgage-group.component';
import { MortgageSummaryComponent } from './component/mortgage-summary/mortgage-summary.component';
import { MortgageComponent } from './component/mortgage/mortgage.component';
import { MyHomeListComponent } from './component/my-home-list/my-home-list.component';
import { MyHomeComponent } from './component/my-home/my-home.component';
import { PropertyFeaturesComponent } from './component/property-features/property-features.component';
import { PropertyMonthlyCostComponent } from './component/property-monthly-cost/property-monthly-cost.component';
import { PropertyOverviewComponent } from './component/property-overview/property-overview.component';
import { RefinanceAllmortageScenarioComponent } from './component/refinance-allmortage-scenario/refinance-allmortage-scenario.component';
import { RefinanceMortgageScenarioComponent } from './component/refinance-mortgage-scenario/refinance-mortgage-scenario.component';
import { RefinanceMortgageComponent } from './component/refinance-mortgage/refinance-mortgage.component';
import { RefinanceComponent } from './component/refinance/refinance.component';
import { RentalDealAnalysisCardComponent } from './component/rental-deal-analysis-card/rental-deal-analysis-card.component';
import { SpendForecastComponent } from './component/spend-forecast/spend-forecast.component';
import { MyHomePageRoutingModule } from './my-home-page-routing.module';

export const customCurrencyMaskConfig = {
  align: 'right',
  allowNegative: true,
  allowZero: true,
  decimal: '.',
  precision: 0,
  prefix: '',
  suffix: '',
  thousands: ',',
  nullable: true,
  min: null,
  max: null,
  inputMode: CurrencyMaskInputMode.NATURAL,
};
export const options: Partial<IConfig> = {
  thousandSeparator: ',',
};

@NgModule({
  declarations: [
    MyHomeListComponent,
    PropertyOverviewComponent,
    MortgageGroupComponent,
    SpendForecastComponent,
    CreateMyHomeDialogueComponent,
    MortgageComponent,
    CreateMortgageDialogComponent,
    MortgageSummaryComponent,
    RefinanceComponent,
    ExtraPaymentComponent,
    MyHomeComponent,
    MiniBarChartComponent,
    PropertyMonthlyCostComponent,
    RefinanceMortgageComponent,
    RefinanceMortgageScenarioComponent,
    CreateRefinanceMortgageScenarioDialogComponent,
    RefinanceAllmortageScenarioComponent,
    ContactAgentInfoComponent,
    HomePropertyDetailsComponent,
    MaintenanceAlertsComponent,
    FinancingComponent,
    ManageMaintenanceAlertsComponent,
    PropertyFeaturesComponent,
    RentalDealAnalysisCardComponent,

  ],
  imports: [
    CommonModule,
    NavigationModule,
    MyHomePageRoutingModule,
    MatButtonModule,
    MatCardModule,
    MatTooltipModule,
    MatTabsModule,
    MatInputModule,
    MatTableModule,
    MatCheckboxModule,
    MatRadioModule,
    MatMenuModule,
    MatDatepickerModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatSlideToggleModule,
    FormsModule,
    ReactiveFormsModule,
    ReactiveFormsModule,
    FormsModule,
    HighchartsChartModule,
    NgxCurrencyModule.forRoot(customCurrencyMaskConfig),
    NgbModule,
    MatSidenavModule,
    MatExpansionModule,
    SharedModule,
    MatProgressBarModule,
    MatSelectModule,
    MatSliderModule,
    NgxMaskModule.forRoot(options),
    MatAutocompleteModule,
    MatChipsModule,
    MatDialogModule,
    CmaModule,

  ],
  exports: [FinancingComponent, PropertyOverviewComponent],
  entryComponents: [CreateMortgageDialogComponent, CreateMyHomeDialogueComponent,],
})
export class MyHomePageModule { }
